module.exports = __webpack_public_path__ + "static/media/WhyChooseXLD-banner.ea546452.jpg";